function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var KEY_ATTRIBUTES_ATTACHMENT = 'attachmentKey';

/**
 * Adds the layer attachments tool for layer
 * @param  {String| Number} layerId layer to process
 * @param  {Function} toolCB function to call on click
 * @param  {Boolean} suppressEvent true to not send event about updated layer (optional)
 */
function addLayerTool(layer, toolCB, suppressEvent) {
  if (!isAdmin()) {
    return;
  }
  var service = getLayerService();
  if (_typeof(layer) !== 'object') {
    // detect layerId and replace with the corresponding layerModel
    layer = service.findMapLayer(layer);
  }
  if (!layer.isLayerOfType('wfs')) {
    // console.log(layer.getType());
    return;
  }
  // add feature data tool for layer
  var tool = Oskari.clazz.create('Oskari.mapframework.domain.Tool');
  tool.setName('layer-attachment');
  // tool.setIconCls('show-file-attachment-tool');
  // TODO: setup some icon for this
  tool.setIconCls('show-layer-legend-tool');
  tool.setTooltip('Attachments');
  tool.setTypes(['selectedLayers']);
  tool.setCallback(function () {
    toolCB(layer.getId());
  });
  service.addToolForLayer(layer, tool, suppressEvent);
}

/**
 * Adds tools for all layers
 * @param  {Function} toolCB function to call on click
 */
function setupLayerTools(toolCB) {
  if (!isAdmin()) {
    return;
  }
  // add tools for feature data layers
  var service = getLayerService();
  var layers = service.getLayersOfType('wfs');
  layers.forEach(function (layer) {
    addLayerTool(layer, toolCB, true);
  });
  // update all layers at once since we suppressed individual events
  var event = Oskari.eventBuilder('MapLayerEvent')(null, 'tool');
  Oskari.getSandbox().notifyAll(event);
}
function isAdmin() {
  return Oskari.user().getRoles().find(function (r) {
    return r.name.includes('Admin');
  });
}
function getLayerService() {
  return Oskari.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
}
function getAttachmentIdFieldName(layerId) {
  var maplayer = LayerHelper.getLayerService().findMapLayer(layerId);
  return maplayer.getAttributes(KEY_ATTRIBUTES_ATTACHMENT) || 'id';
}
function getAttachmentFeatureId(layerId, features) {
  if (features.length !== 1) {
    return;
  }
  var featureProps = features[0];
  var featureMappingField = getAttachmentIdFieldName(layerId);
  return featureProps[featureMappingField];
}
export var LayerHelper = {
  addLayerTool: addLayerTool,
  setupLayerTools: setupLayerTools,
  getLayerService: getLayerService,
  getAttachmentFeatureId: getAttachmentFeatureId,
  getAttachmentIdFieldName: getAttachmentIdFieldName,
  KEY_ATTRIBUTES_ATTACHMENT: KEY_ATTRIBUTES_ATTACHMENT
};